import {refreshTokenAndRetry} from "./UserService";
import {trySetTimeout} from "../hooks/trySetTiemout";

function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}

export const baseUrl = "https://api2.leelaonline.net/api/"
export const wsBaseUrl = "wss://api2.leelaonline.net/api/"
// export const baseUrl = "http://127.0.0.1:8000/api/"

export function execute(request, executeOnReturn, errorRedirect, retries = 3) {
    request().then(
        response => {
            const contentType = response.headers.get('content-type');
            if (response.status === 401) {
                refreshTokenAndRetry(request, executeOnReturn, errorRedirect)
            } else if (!response.ok) {
                errorRedirect(response)
            } else if (contentType && contentType.includes('application/json')) {
                response.json().then(r => executeOnReturn(r))
            } else {
                executeOnReturn(response)
            }
        }
    ).catch((error) => {
        if (retries < 1) {
            console.error("API call failure: ", error.message)
            window.alert("Проблема з'єднання з сервером. Перевірте інтернет підключення і спробуйте ще раз. \n " + error.message)
        } else (
            wait(800 + getRandomInt(400)).then(() => execute(request, executeOnReturn, errorRedirect, retries - 1))
        )
    });

}

function wait(delay){
    return new Promise((resolve) => trySetTimeout(resolve, delay));
}

export function fetchWithRetry(url, fetchOptions = {}, delay, tries) {
    function onError(err){
        const triesLeft = tries - 1;
        if(!triesLeft){
            console.error("Failed fetchWithRetry " + JSON.stringify(fetchOptions), err);
        }
        return wait(delay).then(() => fetchWithRetry(url, fetchOptions, delay, triesLeft));
    }
    return fetch(url,fetchOptions).catch(onError);
}